import { useNavigate } from 'react-router-dom';
import { formatMoneyKr, pluralize } from '../../../utils';
import styles from './ProjectPolls.module.less';
import PollProgressBar from './PollProgressBar';
import { SmallText } from '@sb1/ffe-core-react';

const ProjectPollOption = ({ option, max, countCollectedAmount, canVote, projectId }) => {
    const navigate = useNavigate();
    const value = countCollectedAmount ? parseInt(option.collected_amount, 10) : option.vote_count;
    const formattedValue = countCollectedAmount
        ? `${formatMoneyKr(value)} samlet inn`
        : `${value} ${pluralize(value, 'stemme', 'stemmer')}`;

    const onClickVote = async () => navigate(`/project/${projectId}/payment?projectPollOptionId=${option.id}`);

    return (
        <div className={styles.option}>
            <div className={styles.progressBar} onClick={() => canVote && onClickVote()}>
                <PollProgressBar text={option.text} max={max} value={value} clickable={canVote} />
            </div>
            <div className={styles.optionVotes}>
                <SmallText>{formattedValue}</SmallText>
            </div>
        </div>
    );
};

export default ProjectPollOption;
